import React, { useEffect } from "react"

import FaqTemplate from "../templates/FaqTemplate"
import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

const data = [
    {
        title: "What kinds of dental plans are available?",
        body:
            '\n\t\t<br><p></p><div style="color: #444444;">Like health insurance plans, dental insurance plans are usually categorized as either Indemnity or managed-care plans (Dental PPO plans fit in this latter category). Put broadly, the major differences concern choice of dental care providers, out-of-pocket costs and how bills are paid. Typically, Indemnity plans offer a broader selection of dental care providers than managed-care plans. Indemnity plans pay their share of the costs for covered services only after they receive a bill (which means that you may have to pay up front and then obtain reimbursement from your insurance company).</div><p></p><br>\n<div style="color: #444444;"></div>\n<br><div style="color: #444444;">Managed-care plans typically maintain dental provider networks. Dentists participating in a network agree to perform services for patients at pre-negotiated rates and usually will submit the claim to the dental insurance company for you. In general, you\'ll have less paperwork and lower out-of-pocket costs with a managed-care dental plan and a broader choice of dentists with an Indemnity plan.</div><br>\n\t\t',
    },
    {
        title: "How does dental insurance work?",
        body:
            '\n\t\t<span style="color: #444444;">Dental insurance works in much the same way that medical insurance works. For a specific monthly rate (or "premium"), you are entitled to certain dental benefits, usually including regular checkups, cleanings, x-rays, and certain services required to promote general dental health. Some plans will provide broader coverage than others and some will require a greater financial contribution on your part when services are rendered. Some plans may also provide coverage for certain types of oral surgery, dental implants, or orthodontia.</span>\n\t\t',
    },
]

export default () => {
    useEffect(() => {
        window._waEvents.push("pageView", {
            page: {
                section: "dental-faq",
                name: "page:dental-faq",
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            },
        })
    })

    return (
        <>
            <SEO
                title="Dental FAQs - eHealth Insurance"
                excerpt="Explore information about dental coverage and get more information on how to find an affordable dental plan."
                slug="dental-faq/"
                pageType="resources"
            />
            <FaqTemplate
                data={data}
                categoryName="Dental Insurance"
                categorySlug="dental-insurance"
            />
        </>
    )
}
